import React, {useState} from 'react';
import {Button, Tooltip, Modal} from "antd";

const ServerRefresh = ({refreshTypeFunc, reloadTimeRefetch}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleServerRefresh = async () => {
        setModalVisible(true);
    };

    const handleModalOk = async () => {
        setLoading(true);
        setModalVisible(false);
        await refreshTypeFunc.func();
        reloadTimeRefetch();
        setLoading(false);
    };

    const handleModalCancel = () => {
        setModalVisible(false);
    };

    return (
        <>
            <Tooltip title={refreshTypeFunc.title}>
                <Button
                    style={{
                        float: 'right',
                        zIndex: 1000,
                        position: 'relative',
                        width: 80,
                    }}
                    icon={refreshTypeFunc.icon}
                    onClick={handleServerRefresh}
                    loading={loading}
                />
            </Tooltip>
            <Modal
                open={modalVisible}
                title={refreshTypeFunc.title}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText="확인"
                cancelText="취소"
                confirmLoading={loading}
            >
                <div style={{ whiteSpace: 'pre-line' }}>
                    {refreshTypeFunc.desc}
                </div>
            </Modal>
        </>
    );
};

export default ServerRefresh;